export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#69B514',
    light: '#FFFEF1',
  },
  secondary: {
    main: '#D7D9C4',
    contrastText: '#FFFFFF',
    light: '#D9EDF7',
  },
  text: {
    primary: '#22211F',
    secondary: '#4A5462',
    alternate: '#003C44',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#585858',
    border: '#E5EAF4',
    homeHeroTitle: '#117467',
    footerbg:'#FBFBFB'
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#FFFFFF',
    paper: '#FFF',
    default: '#FFF',
    header: '#F2F6F8',
    footer: '#160900',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#344536',
    tableSubhead: '#F1F1F1',
    tableBorder: '#7D808880',
    tableAlternate: '#FFFFFF',
    alternate: '#E5EAF4',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#D7D9C4',
    secondary: '#F8D859',
    light: '#F8FBFE',
    secondaryLight: 'rgba(238, 246, 250, 0.6)',
    primaryLight: '#D9EDF7',
    ribbon: '#E2F0EE',
    stepCounter: '#69B514',
    stepperCompleted: '#003C44',
    homeHeroWrapper: 'linear-gradient(263deg, #FFF 0.48%, #F2FFED 112.77%)',
  },
  surface: {
    light: '#FFFEF1',
    grey: '#F7F7F7',
    checkbox: '#5B4D43',
    border: '#D9DBE9'
  },
  verticalBar: {
    used: '#025574',
    unused: '#F6F6F6',
    unlimited: '#C0C0C0',
  },
};
